import * as React from 'react';
import Svg, {
  Circle,
  ClipPath,
  Defs,
  G,
  LinearGradient,
  Path,
  Stop,
} from 'react-native-svg';
import { BODY_PARTS, BodyPartsSvgProps } from '../../../components/screens/Game/bodyPartsControls/bodyPartsConstants';
import { BODY_PARTS_SVG_BUTTON_TYPES, BodyPartSvgButton } from '../../../components/helperComponents/BodyPartSvgButton';
/* SVGR has dropped some elements not supported by react-native-svg: filter */


function BodyTypesSVG_foot({ onPress, highlightedParts }: BodyPartsSvgProps) {
  const [_active, setActive] = React.useState<BODY_PARTS | undefined>();

  return (
    <Svg
      style={{ width: '100%', height: '100%' }}
      viewBox="0 0 220 220"
      fill="none"
    >
      <G id="Foot">
        <G id="Foot_2">
          <G id="Group 27715">
            <G id="pressable_leftFoot" clipPath="url(#clip0_5387_9060)">
              <G id="Legs">
                <Path
                  id="Vector"
                  d="M100.825 186.163a6.603 6.603 0 01-7.204 5.515c-1.449.09-2.9-.101-4.277-.563a4.537 4.537 0 01-2.551-2.176 5.477 5.477 0 01-6.266 1.463 3.732 3.732 0 01-.863-.412 5.893 5.893 0 01-2.439.45 6.448 6.448 0 01-3.114-.825 3.77 3.77 0 01-1.575 0 5.365 5.365 0 01-2.702-.976h-.187c-3.752.863-6.078-3.752-4.352-6.978a16.907 16.907 0 013.751-4.202 21.947 21.947 0 004.202-6.078 75.844 75.844 0 015.928-8.855c.263-.412 1.876-2.513 2.026-2.889-.412-3.301 2.801-7.289 2.801-10.778-.093-5.135-1.594-10.467-2.5-15.522-1.539-13.957-3.94-27.951-2.177-42.02a141.064 141.064 0 013.415-20.898A55.221 55.221 0 0084.316 60.4c1.013-10.392-1.95-38.306-2.963-48.774-.413-9.492 16.77-9.342 24.011-8.141 7.241 1.2 16.546 0 17.296 7.503-.3 7.504-6.978 38.907-7.504 46.636a66.82 66.82 0 01-5.214 21.198c-2.402 6.416-1.201 13.694-1.051 20.522a61.383 61.383 0 01-2.251 21.686 190.483 190.483 0 00-4.99 20.56c-.788 6.866 1.05 12.043-.976 19.059.575 2.054.89 4.172.938 6.303 0 1.801-.262 4.503-.187 6.266a5.703 5.703 0 00.563 2.626 9.453 9.453 0 01-1.163 10.318z"
                  fill="#915548"
                />
                <Path
                  id="Vector_2"
                  d="M120.485 11.932c0 .563-.225 1.838-.488 3.752-1.613 10.655-6.64 39.544-7.166 44.609a65.622 65.622 0 01-4.614 17.746 38.527 38.527 0 00-1.651 17.371 75.463 75.463 0 01-.751 21.198c-1.575 6.716-4.389 16.246-5.627 21.948-.67 5.181.044 10.481.713 15.662.147 2.384-.965 4.717-1.876 6.924.62 2.187.96 4.444 1.013 6.716a44.5 44.5 0 000 7.316 29.668 29.668 0 011.613 5.515c.02.175.02.351 0 .526a10.233 10.233 0 01-1.876 4.614 4.65 4.65 0 01-3.001 4.165 13.213 13.213 0 01-6.866 0 3.338 3.338 0 01-1.951-3.414 6.97 6.97 0 01-1.088.6c-.45.263-.788 1.238-1.726 1.951a140.81 140.81 0 00-10.843-.713 3.522 3.522 0 01-4.352-.713 2.514 2.514 0 01-3.752-1.65 4.915 4.915 0 012.176-5.441 21.523 21.523 0 005.14-6.228 69.574 69.574 0 014.803-7.691c2.1-2.926 3.625-4.684 4.424-6.518.136-1.537.518-2.324.831-3.836.865-2.692 1.666-5.268 1.672-8.096 0-4.014-1.938-10.101-2.725-18.468a231.455 231.455 0 01-2.214-26.938 155.405 155.405 0 013.94-30.878 82.31 82.31 0 002.063-19.472c0-4.615-1.989-31.103-2.889-40.032-.563-5.253 10.017-7.504 19.772-6.753 9.755.75 17.559 2.288 17.296 6.228z"
                  fill="url(#paint0_linear_5387_9060)"
                />
                <Path
                  id="Vector_3"
                  style={{
                    mixBlendMode: 'darken',
                  }}
                  d="M88.938 32.41c.674 8.06.874 16.154.6 24.237-.3 2.664 2.702-1.2 5.29-2.326a17.108 17.108 0 00-.262 11.256c1.35 3.414 1.726 4.877.263 5.853a7.167 7.167 0 00-3.415 5.477c0 2.702-5.177 5.703-6.34 15.008a198.44 198.44 0 00.975 36.693 100.927 100.927 0 01.976 20.56 21.65 21.65 0 01-2.214 6.941 13.019 13.019 0 00-.225 4.164c0 .976-2.701 2.814-4.652 5.966-1.951 3.151-6.078 8.929-6.716 9.905a41.689 41.689 0 01-4.127 3.751 7.17 7.17 0 00-1.688 2.477c-.338.75.412.412 1.275-.713a10.65 10.65 0 016.228-3.527 13.876 13.876 0 00-4.24 4.277c-.487 1.051.564 2.326 2.027.563a20.938 20.938 0 016.528-4.54 14.644 14.644 0 00-3.752 4.502c-.375 1.088-.225 1.801.6 1.876.826.075 1.238-.3 2.364-1.988a17.815 17.815 0 015.815-4.615 17.563 17.563 0 00-2.213 3.152c-.338.9-1.088 1.65-1.539 2.701-.45 1.05 0 1.388.45 2.101a3.08 3.08 0 003.302.225c1.05-.6 1.426-.638 1.651-1.651a17.57 17.57 0 013.49-4.502 10.06 10.06 0 001.8-2.664 15.3 15.3 0 01-2.176 4.765 3.303 3.303 0 00-.563 3.077c.225.637 2.326.863 4.427.863 1.654.163 3.322.087 4.953-.226.9-.375 1.763-2.926 1.763-3.751.376 1.2 1.389.187 1.876-1.126a10.246 10.246 0 01-1.876 4.615 4.649 4.649 0 01-3.001 4.164 13.192 13.192 0 01-6.866 0 3.339 3.339 0 01-1.951-3.414 6.966 6.966 0 01-1.088.6c-.45.263-.788 1.239-1.726 1.951a140.82 140.82 0 00-10.843-.712 3.527 3.527 0 01-4.352-.713 2.513 2.513 0 01-3.752-1.651 4.915 4.915 0 012.177-5.44 21.551 21.551 0 005.14-6.228 69.476 69.476 0 014.802-7.692c2.1-2.926 3.752-5.027 4.164-5.777.137-1.538.363-3.066.676-4.578a27.422 27.422 0 001.313-8.329c0-4.014-1.163-9.867-1.951-18.234a231.437 231.437 0 01-2.214-26.938 155.398 155.398 0 013.94-30.877 82.32 82.32 0 002.063-19.473c0-4.614-1.988-31.102-2.889-40.032-.562-5.252 10.018-7.503 19.772-6.753 9.755.75 17.859 2.364 17.597 6.453 0 .563-.226 1.838-.488 3.752a127.38 127.38 0 01-29.565 2.251c-2.363-.525-2.363 6.603-1.613 14.295z"
                  fill="url(#paint1_linear_5387_9060)"
                />
                <Path
                  id="Vector_4"
                  d="M96.698 180.836a3.109 3.109 0 00-1.5-.637 5.813 5.813 0 00-1.614 0 10.97 10.97 0 00-1.538.262 6.762 6.762 0 00-1.5.563 3.748 3.748 0 00-1.013 1.238l-.338.638c-.196.169-.34.39-.413.638 0 .3 0 .637.45.75.285.057.578.057.863 0 .428-.117.87-.18 1.314-.188a8.695 8.695 0 011.388 0h2.776a1.61 1.61 0 001.5-.637c.031-.162.031-.327 0-.488.133-.27.21-.563.226-.863a1.648 1.648 0 00-.6-1.276zm0 2.627a1.059 1.059 0 01-1.05.225l-1.388-.263a8.664 8.664 0 00-1.426-.187h-1.463a8.72 8.72 0 00-1.426.337 1.165 1.165 0 01-.563 0s-.3 0-.3-.262a1.313 1.313 0 010-.488l.6-.675a2.923 2.923 0 011.014-.938c.435-.174.888-.3 1.35-.376h1.463a5.291 5.291 0 012.664.451 1.237 1.237 0 01.638 1.013c.019.149.019.3 0 .45.03.247-.022.498-.15.713h.037zm-12.98-1.651a4.348 4.348 0 00-1.577 0 3.76 3.76 0 00-2.626 1.763c-.138.233-.24.486-.3.751a2.664 2.664 0 000 .863c0 .225 0 .262.338.225h1.2l1.726.187c.312.023.626.023.938 0 .36.004.713-.101 1.013-.3.237-.163.43-.382.563-.638l.412-.637.225-.338a1.011 1.011 0 000-.45 1.2 1.2 0 00-.412-.901 2.884 2.884 0 00-1.538-.525h.037zm1.387 1.726v.337c-.213.389-.54.703-.938.901a2.126 2.126 0 01-.675 0h-.863a7.44 7.44 0 00-1.838 0l-.713.187h-.375c.055-.195.13-.383.225-.562.075-.219.19-.423.337-.601a2.895 2.895 0 012.214-1.238 8.695 8.695 0 011.388 0c.433.017.857.133 1.238.338a.521.521 0 01.263.413s-.3.15-.3.225h.037zm-7.728-1.464a2.864 2.864 0 00-2.477.263 2.666 2.666 0 00-1.238 1.951 2.638 2.638 0 011.463-1.501 2.514 2.514 0 011.951 0 .751.751 0 01.526.488c.075.308.075.63 0 .938a1.912 1.912 0 01-.45.863h-1.314a1.837 1.837 0 00-.788 0h-1.388c-.413 0 0 0-.225-.338a.822.822 0 010-.638 1.243 1.243 0 00-.45 1.089c0 .225.225.337.413.412a5.43 5.43 0 001.538 0h1.426c.278-.03.547-.119.788-.262.368-.223.647-.568.787-.976.217-.401.284-.867.188-1.313a1.605 1.605 0 00-.788-.976h.038zm-4.353-.3a2.027 2.027 0 00-1.313-.675 2.807 2.807 0 00-2.438 1.051 3.392 3.392 0 00-.413.6 1.54 1.54 0 000-.901 1.389 1.389 0 00-1.05-.637 1.87 1.87 0 00-1.164.225 2.845 2.845 0 00-.675.863c-.163.269-.29.559-.375.863v.187c0 .188-.375.3-.45.638a.864.864 0 00.3.825.566.566 0 00.45.263h.225c.203.131.435.208.675.225.254.095.534.095.788 0a.972.972 0 00.713-.9c.233-.272.446-.561.638-.863-.136.2-.214.434-.225.675a.524.524 0 000 .45.71.71 0 00.413.263c.248.036.501.036.75 0h.6c.237.027.476.027.713 0a1.35 1.35 0 00.825-.188c.24-.183.455-.398.638-.638a2.69 2.69 0 00.826-1.088 1.803 1.803 0 00-.488-1.238h.037zm-5.252 2.589a.895.895 0 01-.676.338c-.16.038-.327.038-.487 0l-.525-.225h-.488a1.252 1.252 0 01-.225-.225 4.429 4.429 0 01.863-1.539c.16-.226.364-.417.6-.562a.892.892 0 01.713 0c.262 0 .412-.001.487.262.065.221.065.455 0 .676.038.262-.15.75-.3 1.238l.038.037zm4.802-1.275c-.137.491-.41.933-.788 1.275h-1.5a1.869 1.869 0 00-.788 0h-.6c-.188 0-.226 0-.3-.263.2-.623.547-1.189 1.012-1.65a2.283 2.283 0 011.989-.638 1.167 1.167 0 01.825.413 1.124 1.124 0 01.113.863h.037z"
                  fill="#915548"
                />
                <Path
                  id="Vector_5"
                  d="M87.77 184.736a7.797 7.797 0 000 1.876c.057.619.157 1.234.3 1.839.16.539.36 1.066.6 1.575l.6 1.088a4.536 4.536 0 01-2.55-2.176v-.225a10.726 10.726 0 010-4.239c.06-.726.277-1.43.637-2.064a6.988 6.988 0 011.463-1.501 9.72 9.72 0 001.238-1.5c.371-.542.686-1.12.938-1.726a11.27 11.27 0 01-.637 1.876 7.51 7.51 0 01-1.05 1.763c-.41.487-.786 1.001-1.127 1.538-.26.592-.4 1.23-.412 1.876z"
                  fill="#915548"
                />
                <Path
                  id="Vector_6"
                  d="M79.478 184.508a2.665 2.665 0 00-.375 1.651c.045.553.171 1.097.375 1.613.203.488.495.934.863 1.313l1.35 1.426a3.761 3.761 0 01-1.312 0 3.78 3.78 0 01-.864-.412 3.305 3.305 0 01-1.425-1.764 4.163 4.163 0 01-.263-2.326c.11-.766.392-1.498.826-2.139.4-.566.852-1.094 1.35-1.575.45-.488.863-1.013 1.276-1.539a15.956 15.956 0 013.002-2.738c-.99.901-1.85 1.936-2.552 3.076-.375.525-.713 1.126-1.088 1.688a13.122 13.122 0 00-1.163 1.726z"
                  fill="#915548"
                />
                <Path
                  id="Vector_7"
                  d="M73.623 184.924a3.75 3.75 0 000 1.913 3.75 3.75 0 00.825 1.651c.42.494.898.935 1.426 1.313l1.088.624c-1.091-.008-2.189-.221-3.14-.755l-.312-.357a5.854 5.854 0 01-.863-2.326 4.504 4.504 0 01.3-2.439c.272-.743.68-1.43 1.2-2.026a21.396 21.396 0 011.576-1.613 24.27 24.27 0 013.565-2.626 24.171 24.171 0 00-3.114 3.076c-.45.563-.9 1.126-1.314 1.726a5.89 5.89 0 00-1.237 1.839z"
                  fill="#915548"
                />
                <Path
                  id="Vector_8"
                  d="M69.047 183.763a5.479 5.479 0 000 1.914c.099.611.316 1.197.637 1.726.335.516.725.994 1.163 1.425.376.376.733.327 1.221.74-.972-.074-1.889.05-2.684-.515-.292-.295-.72-.638-.9-1.013a5.55 5.55 0 01-.676-2.288c-.027-.78.1-1.558.376-2.289.26-.718.654-1.38 1.163-1.951a14.792 14.792 0 011.576-1.501 9.315 9.315 0 013.751-2.026 6.77 6.77 0 00-1.838 1.013c-.56.436-1.087.912-1.576 1.426-.49.476-.942.99-1.35 1.538a4.846 4.846 0 00-.863 1.801z"
                  fill="#915548"
                />
              </G>
              <G id="pressable_leftToeNail">
                <Path
                  id="highlight_leftToeNail"
                  d="M92.267 183.688c5.016 0 3.933-1.384 4.288-2.695l-4.833-.048c-1.207.64-4.484 2.91.545 2.743z"
                  fill="#A430FF"
                  fillOpacity={0.25}
                  stroke="#A430FF"
                  strokeWidth={1.5}
                  opacity={highlightedParts.includes(BODY_PARTS.toenails) ? 1 : 0}
                />
              </G>
            </G>
          </G>
          <G id="Group 27716">
            <G id="Group 27645">
              <G id="Group 27630">
                <G id="Group 27629">
                  <Path
                    id="Vector 34"
                    d="M63.866 75.907l3.617.2L91.192 44.67l7.533-13.863 17.88 11.552c-5.208 9.114-5.746 14.51-2.998 23.403.247.798.378 1.641.313 2.475-.693 8.787-4.872 8.78-13.487 6.767-11.322-.707-15.82 2.183-22.5 10.245-4.251 3.898-10.01 5.01-16.876 3.315l-3.817.402c-7.675.664-10.882.032-10.521-5.42.03-.47.409-.84.877-.885l2.311-.224 1.707-1.808 2.611-.703 1.005-1.306 3.616-1.005 2.912-1.105 2.108-.602z"
                    fill="#915548"
                    stroke="#915548"
                  />
                  <Path
                    id="Vector 35"
                    d="M62.863 76.505l4.42-.048 24.471-31.901 7.291-12.833 16.843 11.083c-6.124 9.737-4.889 16.13-2.83 22.548.322 1.001.473 2.061.345 3.105-1.066 8.68-5.333 7.732-13.41 5.846-10.728-.67-16.322 2.584-22.311 10.718-5.944 4.575-10.701 4.522-17.208 2.916l-3.89.94c-7.253.627-10.295.033-9.973-5.095a.96.96 0 01.876-.885l2.148-.208 1.618-1.713 2.474-.666.952-1.238 3.427-.952 2.76-1.047 1.997-.57z"
                    fill="#C68256"
                  />
                  <Path
                    id="Vector 39"
                    d="M97.997 57.837l-3.491 1.831c1.232-.926 3.196-2.138 3.218-3.455.157-2.383.952-4.346 2.278-8.508-.258 3.887-1.098 6.358-2.005 10.132z"
                    fill="#915548"
                  />
                  <Path
                    id="Vector 37"
                    d="M52.225 82.496l-4.461.045 4.147.374-.07.4-.26.365-3.495.14-.034-.488-.441-.652.031 1.697 4.085-.215.518-.656-.02-1.01z"
                    fill="#915548"
                  />
                  <Path
                    id="Vector 38"
                    d="M52.14 82.869l1.283-.355c1.515-1.864 2.658-2.099 4.97-1.91l6.026-1.172 2.981-3.306"
                    stroke="#915548"
                    strokeWidth={0.5}
                  />
                </G>
              </G>
              <G id="pressable_toe">
                <Path
                  id="Highlight_toe"
                  d="M53.543 82.601c1.262-1.682 3.023-1.945 4.974-1.85l6.04-1.018.052 9.542c-1.682-.152-2.626-.317-4.183-.741l-7.83.741c-3.852-.378-5.192-.887-5.972-3.24-.5-2.215-.053-3.61 2.635-3.338l2.838.22 1.446-.316z"
                  fill="#A430FF"
                  fillOpacity={0.25}
                  stroke="#A430FF"
                  opacity={highlightedParts.includes(BODY_PARTS.toe) ? 1 : 0}
                />
              </G>
              <G id="pressable_arc">
                <Path
                  id="highlight_arc"
                  d="M77.617 85.303l-1.244-2.679c5.852-8.118 12.54-11.8 26.533-10.327l-.297 3.21c-14.36-3.037-19.186 3.7-24.992 9.796z"
                  fill="#A430FF"
                  fillOpacity={0.25}
                  stroke="#A430FF"
                  opacity={highlightedParts.includes(BODY_PARTS.arc) ? 1 : 0}
                />
              </G>
            </G>
            <G id="pressable_ankle">
              <Circle
                id="highlight_ankle"
                cx={100.509}
                cy={51.5247}
                r={9.51074}
                fill="#A430FF"
                fillOpacity={0.25}
                stroke="#A430FF"
                opacity={highlightedParts.includes(BODY_PARTS.ankle) ? 1 : 0}
              />
            </G>
          </G>
          <G id="Group 27728">
            <G id="Group">
              <G
                id="Ellipse 83"
                transform="rotate(150 102.487 51.731)"
                fill="#fff"
              >
                <Circle cx={102.487} cy={51.7311} r={2} />
                <Circle cx={102.487} cy={51.7311} r={2} />
              </G>
              <Path
                id="Line 78"
                stroke="#fff"
                d="M166.445 51.9177L101.827 51.9177"
              />
            </G>
            <G id="pressableContainerSelected_ankle">
              <G id="pressableButton_ankle">
                <BodyPartSvgButton
                  type={BODY_PARTS_SVG_BUTTON_TYPES.activate}
                  bodyPart={BODY_PARTS.ankle}
                  activateAsSelect
                  onPress={onPress}
                  onActivate={setActive}
                  width={61}
                  height={32}
                  x={157}
                  y={35.5}
                />
              </G>
            </G>
          </G>
          <G id="Group 27729">
            <G id="Group_2">
              <G
                id="Ellipse 83_2"
                transform="rotate(-30 53.226 85.774)"
                fill="#fff"
              >
                <Circle cx={53.2262} cy={85.7742} r={2} />
                <Circle cx={53.2262} cy={85.7742} r={2} />
              </G>
              <Path
                id="Line 78_2"
                stroke="#fff"
                d="M34.9518 53.098L54.316 85.8333"
              />
            </G>
            <G id="pressableContainerSelected_toe">
              <G id="pressableButton_toe">
                <BodyPartSvgButton
                  type={BODY_PARTS_SVG_BUTTON_TYPES.activate}
                  bodyPart={BODY_PARTS.toe}
                  activateAsSelect
                  onPress={onPress}
                  onActivate={setActive}
                  width={61}
                  height={32}
                  x={1.5}
                  y={26.5}
                />
              </G>
            </G>
          </G>
          <G id="Group 27730">
            <G id="Group_3">
              <G
                id="Ellipse 83_3"
                transform="rotate(150 88.104 75.65)"
                fill="#fff"
              >
                <Circle cx={88.1039} cy={75.6504} r={2} />
                <Circle cx={88.1039} cy={75.6504} r={2} />
              </G>
              <Path
                id="Line 78_3"
                d="M157.758 101.734L87.443 75.837"
                stroke="#fff"
              />
            </G>
            <G id="pressableContainerSelected_arch">
              <G id="pressableButton_arch">
                <BodyPartSvgButton
                  type={BODY_PARTS_SVG_BUTTON_TYPES.activate}
                  bodyPart={BODY_PARTS.arc}
                  activateAsSelect
                  onPress={onPress}
                  onActivate={setActive}
                  width={61}
                  height={32}
                  x={157}
                  y={86}
                />
              </G>
            </G>
          </G>
          <G id="Group 27727">
            <G id="Group_4">
              <G
                id="Ellipse 83_4"
                transform="rotate(174.48 94.66 182.584)"
                fill="#fff"
              >
                <Circle cx={94.6606} cy={182.584} r={2} />
                <Circle cx={94.6606} cy={182.584} r={2} />
              </G>
              <Path
                id="Line 78_4"
                stroke="#fff"
                d="M152.303 182.525L94.1926 182.525"
              />
            </G>
            <G id="pressableContainerSelected_toeNails">
              <G id="pressableButton_toeNails">
                <BodyPartSvgButton
                  type={BODY_PARTS_SVG_BUTTON_TYPES.activate}
                  bodyPart={BODY_PARTS.toenails}
                  activateAsSelect
                  onPress={onPress}
                  onActivate={setActive}
                  width={86}
                  height={32}
                  x={133}
                  y={166}
                />
              </G>
            </G>
          </G>
        </G>
      </G>
      <Defs>
        <LinearGradient
          id="paint0_linear_5387_9060"
          x1={70.2105}
          y1={21.9868}
          x2={91.821}
          y2={94.0221}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#C68256" />
          <Stop offset={1} stopColor="#C68256" />
        </LinearGradient>
        <LinearGradient
          id="paint1_linear_5387_9060"
          x1={65.6683}
          y1={97.8037}
          x2={120.483}
          y2={97.8037}
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#C97551" />
          <Stop offset={1} stopColor="#C97551" stopOpacity={0} />
        </LinearGradient>
        <ClipPath id="clip0_5387_9060">
          <Path
            fill="#fff"
            transform="matrix(1 0 0 -1 55.113 193.735)"
            d="M0 0H57.841V50.457H0z"
          />
        </ClipPath>
      </Defs>
    </Svg>
  );
}

export { BodyTypesSVG_foot };
